import React from 'react';

const EnterpriseConsiderations = () => {
  return (
    <>
      {/* Enterprise Considerations */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">Enterprise Considerations</h3>
      <p className="text-gray-700 leading-relaxed mb-6">
        Along with an extensive set of features, tools, and capabilities, ASI1 is also built to be secure, trustworthy, and scalable for wide-reaching enterprise needs in the Web3 ecosystem.
      </p>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-12">
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg">
            <thead className="bg-blue-100">
              <tr>
                <th className="text-left p-4 border-b font-semibold">Feature</th>
                <th className="text-left p-4 border-b font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-4 border-b font-medium"><strong>Secure</strong></td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Web3-native security with decentralized data handling capabilities</li>
                    <li>• Enterprise-grade blockchain integration with audit trail support</li>
                    <li>• Secure agent-to-agent communication across distributed networks</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b font-medium"><strong>Trustworthy</strong></td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Resistant to manipulation and adversarial attacks in DeFi environments</li>
                    <li>• Transparent decision-making with verifiable reasoning chains</li>
                    <li>• Uniquely positioned for high-trust financial applications and compliance</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b font-medium"><strong>Capable</strong></td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Advanced agentic reasoning for multi-step autonomous operations</li>
                    <li>• Native Web3 protocol understanding and multi-protocol compatibility</li>
                    <li>• Real-time market analysis and adaptive trading strategies</li>
                    <li>• Comprehensive SDK and API support for seamless integration</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b font-medium"><strong>Reliable</strong></td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Very low hallucination rates for financial and trading data</li>
                    <li>• Accurate analysis across complex blockchain networks and protocols</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b font-medium"><strong>Global</strong></td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Multi-chain support across Ethereum, Binance Smart Chain, Polygon, and more</li>
                    <li>• International DeFi compliance and regulatory understanding</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 font-medium"><strong>Cost conscious</strong></td>
                <td className="p-4">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Family of models optimized for different Web3 use cases and transaction volumes</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default EnterpriseConsiderations;
